import { createFilterStore } from './createFilterStore';

export const useAgreementFilterStore = createFilterStore({
  page: 1,
  limit: 20,
  search: '',
  status: '',
  kind: '',
  sortBy: 'createdAt',
  sortOrder: 'desc' as const,
});
